/**
 * Main navigation sections that can be active in the top-level navbar
 * These correspond to the main tabs: Performance, Company, Engagement, etc.
 */
export const MainNavSections = {
	/**
	 * Performance/My Info section - user-specific pages like dashboard, reviews, feedback, goals
	 */
	PERFORMANCE: "performance",

	/**
	 * Company section - company-wide pages like directory, org chart, company reviews
	 */
	COMPANY: "company",

	/**
	 * Engagement section - pulse surveys, engagement analytics
	 */
	ENGAGEMENT: "engagement",

	/**
	 * Meeting Workspaces section
	 */
	MEETING_WORKSPACES: "meeting-workspaces",

	/**
	 * Surveys section
	 */
	SURVEYS: "surveys",

	/**
	 * Analytics/Reporting section
	 */
	ANALYTICS: "analytics",

	/**
	 * Administration section - admin settings and configuration
	 */
	ADMINISTRATION: "administration",

	/**
	 * Special value: Keep the last active main nav section
	 * Useful for modal routes or overlay pages that shouldn't change the active nav
	 */
	KEEP_LAST: "keepLast",
} as const;

export type MainNavSection = (typeof MainNavSections)[keyof typeof MainNavSections];

/**
 * Type guard to check if a value is a valid MainNavSection
 */
export function isMainNavSection(value: unknown): value is MainNavSection {
	return typeof value === "string" && Object.values(MainNavSections).includes(value as MainNavSection);
}
